import { useEffect, useState } from "react";

type Theme = "system" | "light" | "dark";

export function useDarkMode() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window === "undefined") return "system";
    return (localStorage.getItem("theme") as Theme) ?? "system";
  });

  useEffect(() => {
    const root = document.documentElement;

    if (theme === "system") {
      localStorage.removeItem("theme");
      root.removeAttribute("data-theme");
    } else {
      localStorage.setItem("theme", theme);
      root.setAttribute("data-theme", theme);
    }

    // Apply class for forced dark mode
    if (theme === "dark") {
      root.style.colorScheme = "dark";
    } else if (theme === "light") {
      root.style.colorScheme = "light";
    } else {
      root.style.colorScheme = "";
    }
  }, [theme]);

  const cycle = () => {
    setTheme((t) => {
      if (t === "system") return "dark";
      if (t === "dark") return "light";
      return "system";
    });
  };

  return { theme, setTheme, cycle };
}
